import Service from '../../services'


// initial state
const state = {
    industrySearched: {},
    industriesSearched: {},
    industryType: true,
    stateLoaded: false
};


// getters
const getters = {

};


// actions
const actions = {
    searchedDataIndustry({ commit, state }, params) {
        Service.chartdata.getChartData(params.id, params.year).then((res) => {
            // console.log('res0',res[0]);
            commit('setSearchedData',res[0]);
        }).then(() => {
            console.log('setSearched success');
        });
    },

    searchedAllIndustryByYear({ commit, state }, year) {
        Service.chartdata.getAllIndustriesByYear(year).then((res) => {
            console.log('All industry by year',res[0]);
            commit('setSearchedData',res[0]);
        }).then(() => {
            console.log('setSearchedAll success');
        })
    },

    clearSearch({ commit, state }) {
        commit('clearState');
    },

    setIndustryType({ commit, state }, type) {
        commit('setIndustryTypeState',type);
    },

    setLoadState ({ commit, state }, bool) {
        commit('setGraphLoadedState', bool);
    }
};


// mutations
const mutations = {
    setSearchedData(state, data) {
        state.industrySearched = data;
    },

    clearState(state){
        state.industrySearched = {};
    },

    setIndustryTypeState(state, data) {
        state.industryType = data;
    },

    setGraphLoadedState(state, data) {
        state.stateLoaded = data;
    }
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
